import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { validationErrorsToString } from '../../../utils';

// PACKAGES
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import LoadingSpinner from '../../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../../components/GlobalModal';

interface RemoveModalTypes {
	closeModal?: closeModalType;
	update: () => void;
	userProfileId: string;
	volunteerStatus: string;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({ closeModal, update, userProfileId, volunteerStatus }) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const removeVolunteerStatus = async () => {
		setIsLoading(true);

		const response = await apibridge.postAccountVolunteerRemove({ userProfileId: userProfileId });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);
			closeModal && closeModal();
			update();
		}
	};

	const widthdrawVolunteerStatus = async () => {
		setIsLoading(true);

		const response = await apibridge.postAccountVolunteerRevoke({ userProfileId: userProfileId });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);
			closeModal && closeModal();
			update();
		}
	};

	const submit = () => {
		if (volunteerStatus === 'Withdraw') {
			widthdrawVolunteerStatus();
		} else {
			removeVolunteerStatus();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to <strong>{volunteerStatus.toLowerCase()}</strong> your volunteer status?
								</h2>
								<div className="form-button-group">
									<Button
										disabled={isLoading}
										className="full-width btn-primary form-group"
										type="button"
										onClick={() => submit()}
									>
										{volunteerStatus}
									</Button>
									<Button
										disabled={isLoading}
										className="full-width btn-secondary"
										type="button"
										onClick={() => {
											closeModal && closeModal();
										}}
									>
										Cancel
									</Button>
								</div>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
